<template>
  <div>
    <div class="row stats-row">
      <div class="col-xs-6 col-sm-4 col-md" v-if="userRole=='super-admin'">
        <router-link :to="'/' + userUrl + '/pickls?status=COMPLETED'">
          <Card
            icon="Dashboard/ActivePickl_icon.png"
            :value="busy ? 'Loading...' : dashboardContent.completed_pickls_count ? dashboardContent.completed_pickls_count:0"
            caption="Awaiting Approval"
            color="#6B8F5E"
          />
        </router-link>
      </div>
      <div class="col-xs-6 col-sm-4 col-md" v-if="userRole=='super-admin'">
        <router-link :to="'/' + userUrl + '/picklrs?status=ACTIVE'">
          <Card
            icon="Dashboard/ActivePicklrs_icon.png"
            :value="busy ? 'Loading...' : dashboardContent.active_picklrs_count?dashboardContent.active_picklrs_count:0"
            caption="Users"
            color="#7c9a92"
          />
        </router-link>
      </div>
      <div class="col-xs-6 col-sm-4 col-md" v-if="userRole=='super-admin'">
        <router-link :to="'/' + userUrl + '/brands'">
          <Card
            icon="Dashboard/brandsigned_icon.png"
            :value="busy ? 'Loading...' : dashboardContent.active_brands_count?dashboardContent.active_brands_count:0"
            caption="Awesome Companies"
            color="#8a9bae"
          />
        </router-link>
      </div>
      <div class="col-xs-6 col-sm-6 col-md" v-if="userRole=='super-admin'">
        <router-link :to="'/' + userUrl + '/brand-subscription-history'">
          <Card
            icon="Dashboard/brandpayment_icon.png"
            :value="busy ? 'Loading...' : dashboardContent.total_brand_payments?'$' + dashboardContent.total_brand_payments:0"
            caption="Gross Revenue"
            color="#7aaa6e"
          />
        </router-link>
      </div>
      <div class="col-xs-6 col-sm-6 col-md" v-if="userRole=='super-admin'">
        <router-link :to="'/' + userUrl + '/picklrs?sortBy=current_credits-DESC'">
          <Card
            icon="Dashboard/OutstandingAmount_icon.png"
            :value="loadingStripeBalance ? 'Loading...' : stripeBalance?'$' + stripeBalance:0"
            caption="Stripe Balance"
            color="#b5936b"
          />
        </router-link>
      </div>
    </div>

    <h3 class="section-title" v-if="userRole=='super-admin'">Summary</h3>
    <div class="col-xs-12 green-border-box panel-box white-bg" v-if="userRole=='super-admin'">
      <div class="col-xs-12 col-sm-9 col-lg-10 nopadd">
        <ul class="nav nav-tabs" role="tablist">
          <li role="presentation" class="active">
            <a
              href="#pickl"
              aria-controls="pickl"
              role="tab"
              data-toggle="tab"
              @click="switchTab('pickl')"
            >PICKL</a>
          </li>
          <li role="presentation">
            <a
              ref="amount"
              href="#pickl"
              aria-controls="pickl"
              role="tab"
              data-toggle="tab"
              @click="switchTab('payment')"
            >AMOUNT</a>
          </li>
        </ul>
      </div>
      <div class="col-xs-12 col-sm-3 col-lg-2 nopadd text-center sort-control">
        View By
        <select v-model="viewby">
          <option selected value="1y">Year</option>
          <option selected value="6m">6 Months</option>
          <option selected value="3m">3 Months</option>
          <option selected value="1m">Month</option>
        </select>
      </div>
      <div class="col-xs-12 nopadd">
        <div class="tab-content">
          <div
            role="tabpanel"
            class="tab-pane fade in active"
            :class="'filter' + viewby"
            id="pickl"
          >
            <apexcharts height="250" type="area" :options="chartOptions" :series="chartData"/>
          </div>
        </div>
      </div>
    </div>
    <h3 class="section-title" v-if="userRole=='super-admin'">Task Demographics</h3>
    <div class="row demographics-row">
      <div class="col-xs-12 col-sm-4" v-if="userRole=='super-admin'">
        <div class="green-border-box panel-box white-bg">
          <h4 class="panel-title">User Task Counts</h4>
          <ul class="demo-list">
            <li v-for="uc in usersCountTasks" :key="uc.users">
              <strong>{{uc.users}} tasks</strong> <span>{{uc.count}} users</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-xs-12 col-sm-4" v-if="userRole=='super-admin'">
        <div class="green-border-box panel-box white-bg">
          <h4 class="panel-title">User Task Counts State Wise</h4>
          <ul class="demo-list">
            <li v-for="uc in usersCountTasks" :key="uc.users">
              <strong>{{uc.users}} states</strong> <span>{{uc.count}} users</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-xs-12 col-sm-4" v-if="userRole=='super-admin'">
        <div class="green-border-box panel-box white-bg">
          <h4 class="panel-title">Company Counts For Tasks Per State</h4>
          <ul class="demo-list">
            <li v-for="bc in brandsCountTasks" :key="bc.states">
              <strong>{{bc.states}} states</strong> <span>{{bc.count}} companies</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-8" v-if="userRole=='super-admin'">
        <div class="green-border-box panel-box white-bg">
          <h4 class="panel-title">Age Demographics</h4>
          <div class="col-xs-12 nopadd">
            <apexcharts height="220" type="area" :options="chartOptions" :series="ageDemographics"/>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-4" v-if="userRole=='super-admin'">
        <div class="green-border-box panel-box white-bg">
          <h4 class="panel-title">Gender Demographics</h4>
          <ul class="demo-list">
            <li v-for="(gender, index) in genderDemographics" :key="index">
              <strong>{{gender.gender !== null ? gender.gender : 'Unknown'}}</strong> <span>{{gender.total}}</span>
            </li>
          </ul>
          <hr class="panel-divider"/>
          <h4 class="panel-title">Children Demographics</h4>
          <ul class="demo-list">
            <li v-for="(children, index) in childrenDemographics" :key="index">
              <strong>{{children.children !== null ? children.children : 'Unknown'}}</strong> <span>{{children.total}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-6">
        <div class="green-border-box panel-box white-bg" v-if="userRole=='super-admin'">
          <div class="panel-header">
            <h4 class="panel-title">Pickl Average Times</h4>
            <div class="sort-control">
              <select v-model="viewAverageTime">
                <option selected value="all-time">All Time</option>
                <option selected value="year-2019">2019</option>
                <option selected value="year-2020">2020</option>
                <option selected value="year-2021">2021</option>
                <option selected value="year-2022">2022</option>
                <option selected value="last-1y">Last Year</option>
                <option selected value="last-6m">6 Months</option>
                <option selected value="last-3m">3 Months</option>
                <option selected value="last-1m">1 Month</option>
              </select>
            </div>
          </div>
          <table class="table table-compact">
            <thead>
              <tr>
                <th>Journey</th>
                <th>Average Time</th>
              </tr>
            </thead>
            <tbody v-if="!loadingPicklAverageTimes">
              <tr v-for="(value, key) in averagePicklTimes" :key="key">
                <td>{{key}}</td>
                <td>{{value}}</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr><td colspan="2" style="text-align:center;">Loading Data...</td></tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-xs-12 col-sm-6">
        <div class="green-border-box panel-box white-bg" v-if="userRole=='super-admin'">
          <div class="panel-header">
            <h4 class="panel-title">Launched v/s Completed Tasks</h4>
            <div class="sort-control">
              <select v-model="getComparisionTime">
                <option selected value="all-time">All Time</option>
                <option selected value="year-2019">2019</option>
                <option selected value="year-2020">2020</option>
                <option selected value="year-2021">2021</option>
                <option selected value="year-2022">2022</option>
                <option selected value="last-1y">Last Year</option>
                <option selected value="last-6m">6 Months</option>
                <option selected value="last-3m">3 Months</option>
                <option selected value="last-1m">1 Month</option>
              </select>
            </div>
          </div>
          <apexcharts type="area" height="220" :options="barChartOptions" :series="series"></apexcharts>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import Card from '@/components/common/Card.vue'

export default {
  name: 'Dashboard',
  components: {
    Card,
    apexcharts: VueApexCharts
  },
  data: function () {
    return {
      loadingStripeBalance: true,
      stripeBalance: 0,
      usersCountTasks: [],
      brandsCountTasks: [],
      genderDemographics: [],
      loadingPicklAverageTimes: true,
      averagePicklTimes: [],
      busy: true,
      allChartData: [],
      viewby: '1y',
      viewAverageTime: 'last-1y',
      getComparisionTime: 'last-1y',
      activeTab: 'pickl',
      chartData: [],
      ageDemographics: [],
      paymentChartData: [],
      dashboardContent: {},
      childrenDemographics: {},
      userRole: 'staff',
      userUrl: 'sadmin',
      series: [{
        name: 'Tasks Created',
        data: [250, 200, 240, 245, 200, 210, 280, 300, 150]
      }, {
        name: 'Tasks Completed',
        data: [240, 180, 220, 240, 190, 205, 260, 280, 130]
      }],
      barChartOptions: {
        chart: {
          type: 'area',
          height: 350
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded'
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        xaxis: {
          categories: ['Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb']
        },
        yaxis: {
          title: {
            text: 'Tasks'
          }
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + 'pickls'
            }
          }
        }
      },
      chartOptions: {
        chart: {
          id: 'pickl-graph',
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false
          }
        },
        xaxis: {
          labels: {
            rotate: 0
          }
        },
        markers: {
          size: 0,
          style: 'hollow',
          strokeColor: '#6B8F5E',
          colors: '#ffffff'
        },
        colors: ['#00E05E', '#EBFCF2'],
        grid: {
          borderColor: '#F2F2F2',
          clipMarkers: false
        },
        dataLabels: {
          enabled: false
        },
        fill: {
          type: 'solid',
          colors: ['#00e05e'],
          opacity: 0.08,
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 1,
            opacityTo: 1
          }
        },
        stroke: {
          width: 2,
          colors: ['#00E05E']
        },
        tooltip: {
          x: {
            show: false
          },
          custom: function ({ series, seriesIndex, dataPointIndex }) {
            return '<div class="graph-tooltip">' + series[seriesIndex][dataPointIndex] + '</div>'
          },
          marker: {
            show: true
          }
        },
        yaxis: {
          min: 0,
          tickAmount: 4,
          labels: {
            style: {
              cssClass: 'graph-label'
            }
          }
        }
      }
    }
  },
  methods: {
    getSadminDashboard () {
      this.busy = true
      this.$http
        .get('dashboard')
        .then(
          function (response) {
            this.dashboardContent = response.body.data
            this.busy = false
          },
          function (response) {
            this.errorMessage = response.body.message
            this.busy = false
          }
        )
    },
    getSadminReports () {
      this.$http
        .get('dashboard/reports?view=' + this.viewby)
        .then(
          function (response) {
            this.allChartData = response.body
            this.showChartData()
          },
          function (response) {
            this.errorMessage = response.body.message
          }
        )
    },
    getPicklAverageTimes () {
      this.averagePicklTimes = []
      this.loadingPicklAverageTimes = true
      this.$http
        .get('dashboard/pickl-average-times?view=' + this.viewAverageTime)
        .then(
          function (response) {
            this.loadingPicklAverageTimes = false
            this.averagePicklTimes = response.body.pickl_data
          },
          function (response) {
            this.errorMessage = response.body.message
          }
        )
    },

    createPicklComparisionChart () {
      this.$http
        .get('dashboard/pickl-comparision-chart?view=' + this.getComparisionTime)
        .then(
          function (response) {
            this.loadingPicklAverageTimes = false
            this.averagePicklTimes = response.body.pickl_data
          },
          function (response) {
            this.errorMessage = response.body.message
          }
        )
    },

    switchTab (value) {
      this.activeTab = value
      this.showChartData()
    },
    showChartData () {
      if (this.activeTab === 'pickl') {
        this.chartData = [{
          name: 'PICKL',
          data: this.allChartData.pickl_data
        }]
      } else {
        this.chartData = [{
          name: 'PAYMENT',
          data: this.allChartData.payment_data
        }]
      }
    },
    getAgeDemographics () {
      this.$http
        .get('dashboard/age-demographics')
        .then(
          function (response) {
            this.ageDemographics = [{
              name: 'AGE',
              data: response.body.data
            }]
          },
          function (response) {
            this.errorMessage = response.body.message
          }
        )
    },
    getUserTaskCounts () {
      this.$http
        .get('dashboard/user-tasks-count')
        .then(
          function (response) {
            this.usersCountTasks = response.body.data
            console.log(this.usersCountTasks)
          },
          function (response) {
            this.errorMessage = response.body.message
          }
        )
    },
    getBrandTaskCounts () {
      this.$http
        .get('dashboard/brand-tasks-count-with-states')
        .then(
          function (response) {
            this.brandsCountTasks = response.body.data
            console.log(this.brandsCountTasks)
          },
          function (response) {
            this.errorMessage = response.body.message
          }
        )
    },
    getGenderDemographics () {
      this.$http
        .get('dashboard/gender-demographics')
        .then(
          function (response) {
            this.genderDemographics = response.body.data
          },
          function (response) {
            this.errorMessage = response.body.message
          }
        )
    },
    getChildrenDemographics () {
      this.$http
        .get('dashboard/children-demographics')
        .then(
          function (response) {
            this.childrenDemographics = response.body.data
          },
          function (response) {
            this.errorMessage = response.body.message
          }
        )
    },
    getStripeBalance () {
      this.$http.get('dashboard/get-stripe-balance').then((response) => {
        this.stripeBalance = response.data.data.available[0]['amount'] / 100
        this.loadingStripeBalance = false
      })
    }
  },

  mounted () {
    let userData = this.$store.state.userData
    this.userRole = userData.role
    if (this.userRole === 'super-admin') {
      this.userUrl = 'sadmin'
    } else {
      this.userUrl = 'staff'
    }
    this.getStripeBalance()
    this.getSadminReports()
    this.getSadminDashboard()
    this.getPicklAverageTimes()
    // this.createPicklComparisionChart()
    this.getAgeDemographics()
    this.getGenderDemographics()
    this.getChildrenDemographics()
    this.getBrandTaskCounts()
    this.getUserTaskCounts()
  },
  watch: {
    viewby () {
      this.getSadminReports()
    },
    viewAverageTime () {
      this.getPicklAverageTimes()
    }
  }
}
</script>

<style scoped>
.stats-row {
  display: flex;
  flex-wrap: wrap;
}
.stats-row > div {
  flex: 1;
  min-width: 0;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #1a202c;
  margin: 16px 0 10px;
}

.panel-box {
  padding: 14px;
  margin-bottom: 14px;
  border-radius: 8px;
}

.panel-title {
  font-size: 13px;
  font-weight: 600;
  color: #1a202c;
  margin: 0 0 10px;
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.panel-header .panel-title {
  margin: 0;
}

.panel-divider {
  margin: 10px 0;
  border-color: #e2e8f0;
}

.demo-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.demo-list li {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
  font-size: 12px;
  color: #4a5568;
  border-bottom: 1px solid #f0f0f0;
}
.demo-list li:last-child {
  border-bottom: none;
}
.demo-list li strong {
  font-weight: 600;
  color: #1a202c;
}

.demographics-row {
  margin-bottom: 4px;
}

.table-compact {
  font-size: 12px;
  margin-bottom: 0;
}
.table-compact thead th {
  font-size: 11px;
  font-weight: 600;
  color: #4a5568;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  border-bottom: 2px solid #e2e8f0;
  padding: 6px 8px;
}
.table-compact tbody td {
  padding: 5px 8px;
  color: #1a202c;
  border-top: 1px solid #f0f0f0;
}

.tab-content {
  overflow: hidden;
}

>>> .graph-label,
>>> .apexcharts-xaxis tspan {
  color: rgba(0, 0, 0, 0.6);
  font-family: 'Inter', sans-serif !important;
  font-size: 11px;
}

>>> .graph-label {
  font-size: 11px;
}

>>> .apexcharts-tooltip {
  overflow: visible;
}

>>> .graph-tooltip {
  position: relative;
  background: #6B8F5E;
  color: #fff;
  font-weight: 500;
  font-size: 12px;
  padding: 3px 8px;
  border-radius: 4px;
}

@media only screen and (max-width: 991px) and (min-width: 576px) {
  >>> .apexcharts-xaxis-label:nth-last-child(even) {
    display: none;
  }
}

@media only screen and (max-width: 767px) and (min-width: 576px) {
  .sort-control {
    margin-top: 10px;
  }

  >>> .filter3m .apexcharts-xaxis-label,
  >>> .filter1m .apexcharts-xaxis-label {
    display: none;
  }

  >>> .filter3m .apexcharts-xaxis-label:first-child,
  >>> .filter3m .apexcharts-xaxis-label:nth-last-child(2),
  >>> .filter1m .apexcharts-xaxis-label:first-child,
  >>> .filter1m .apexcharts-xaxis-label:nth-last-child(2),
  >>> .filter3m .apexcharts-xaxis-label:nth-last-child(5),
  >>> .filter1m .apexcharts-xaxis-label:nth-last-child(4) {
    display: block;
  }
}

@media only screen and (max-width: 575px) {
  .sort-control {
    margin-top: 10px;
  }

  >>> .apexcharts-xaxis tspan {
    font-size: 10px;
  }

  .panel-box {
    padding: 10px;
  }

  >>> .filter6m .apexcharts-xaxis-label:nth-last-child(2n) {
    display: none;
  }

  >>> .filter1y .apexcharts-xaxis-label:nth-last-child(4n-1),
  >>> .filter1y .apexcharts-xaxis-label:nth-last-child(4n),
  >>> .filter1y .apexcharts-xaxis-label:nth-last-child(4n-2) {
    display: none;
  }

  >>> .filter3m .apexcharts-xaxis-label,
  >>> .filter1m .apexcharts-xaxis-label {
    display: none;
  }

  >>> .filter3m .apexcharts-xaxis-label:first-child,
  >>> .filter3m .apexcharts-xaxis-label:nth-last-child(2),
  >>> .filter1m .apexcharts-xaxis-label:first-child,
  >>> .filter1m .apexcharts-xaxis-label:nth-last-child(2) {
    display: block;
  }

  .stats-row > div {
    flex: 0 0 50%;
  }
}
</style>
